var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"23fc3ac478bb31d8cd961153659c463279e516a1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["comimag-staging"]={id:"23fc3ac478bb31d8cd961153659c463279e516a1"};
      